import { Button, RobotIcon, CloseIcon } from "@fluentui/react-northstar";
import { useChatStore } from "../../stores/useChatStore";
import Yeetchicon from "../../assets/chatbot/Yeetchi v2.svg";

const buttonStyle = {
    position: "fixed",
    bottom: "24px",
    right: "24px",
    width: "60px",
    height: "60px",
    borderRadius: "50%",
    zIndex: 1000,
    boxShadow: "0 8px 24px rgba(0, 0, 0, 0.15)",
    overflow: "hidden",
};

const ChatbotButton = () => {
    const { isOpen, toggleChat } = useChatStore();

    return (
        <Button
            id="chatbot-toggle-button"
            circular
            primary
            // icon={isOpen ? <CloseIcon /> : <RobotIcon size="large" />}
            icon={
                isOpen ? (
                    <CloseIcon />
                ) : (
                    <img
                        src={Yeetchicon}
                        alt="Yeetch Icon"
                        style={{ width: 43, height: 43 }}
                    />
                )
            }
            onClick={(e) => {
                e.preventDefault();
                toggleChat();
            }}
            aria-label="Toggle chat"
            styles={buttonStyle}
        />
    );
};

export default ChatbotButton;
